module.exports = __webpack_public_path__ + "media/images/détecteur de fumée-de805f74855302741e5118c6266c068d.svg";